module.exports = __webpack_public_path__ + "img/0910b_cover.4a452cd4.jpg";